import React from 'react'
import { CardBodyCentered, Plate, StateHeadline } from '../ItineraryImportPage.styles'

interface CenteredStateProps {
	tone: 'orange' | 'red' | 'blue' | 'gold'
	icon: React.ReactNode
	headline: string
	children: React.ReactNode
}

/**
 * Shared scaffold for the centered terminal states (no-events, failed,
 * rate-limit, stuck, import-cleared): a tinted icon plate, a headline, then
 * arbitrary body content.
 */
const CenteredState: React.FC<CenteredStateProps> = ({ tone, icon, headline, children }) => (
	<CardBodyCentered>
		<Plate $tone={tone}>{icon}</Plate>
		<StateHeadline>{headline}</StateHeadline>
		{children}
	</CardBodyCentered>
)

export default CenteredState
